import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GridOptions } from 'ag-grid-community';
import { LoaderService } from 'src/Core/loader.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class AppComponent {

  loading$ = this.loaderService.loading$; // No manual subscription needed

  constructor(private loaderService: LoaderService,private titleService: Title) {
    this.titleService.setTitle(environment.appTitle);
   }

  ngOnInit(): void { }


}